import { render } from "./ProductSelectionProductsSelectionItemBadge.vue?vue&type=template&id=5dfa69d0&scoped=true&ts=true"
import script from "./ProductSelectionProductsSelectionItemBadge.vue?vue&type=script&lang=ts"
export * from "./ProductSelectionProductsSelectionItemBadge.vue?vue&type=script&lang=ts"

import "./ProductSelectionProductsSelectionItemBadge.vue?vue&type=style&index=0&id=5dfa69d0&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dfa69d0"]])

export default __exports__